import PropTypes from 'prop-types';
import React from 'react';
import CalendarOnRedemptionProduct from './CalendarOnRedemptionProduct';

const CalendarOnRedemptionProducts = ({
  currency,
  products,
  selection,
  quantity,
  onSelect,
  onQuantityChange,
}) => {
  return (
    <>
      <div className="booking-calendar__products">
        {products.map((product, index) => (
          <CalendarOnRedemptionProduct
            currency={currency}
            key={index}
            onQuantityChange={onQuantityChange}
            onSelect={onSelect}
            product={product.tiers[0]}
            quantity={quantity}
            selected={
              selection?.dealVoucherProductId ===
              product.tiers[0].dealVoucherProductId
            }
          />
        ))}
      </div>
      <style jsx>{`
        .booking-calendar__products {
          margin-bottom: 20px;
        }
      `}</style>
    </>
  );
};

CalendarOnRedemptionProducts.propTypes = {
  currency: PropTypes.string,
  onQuantityChange: PropTypes.func,
  onSelect: PropTypes.func,
  products: PropTypes.array,
  quantity: PropTypes.number,
  selection: PropTypes.object,
};

CalendarOnRedemptionProducts.defaultProps = {
  currency: 'gbp',
  onQuantityChange: () => false,
  onSelect: () => false,
  products: [],
  quantity: 1,
  selection: null,
};

export default CalendarOnRedemptionProducts;
